/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type BlobStorageIntegrationType =
  | "S3"
  | "S3_COMPATIBLE"
  | "AZURE_BLOB_STORAGE";
export const BlobStorageIntegrationType = {
  S3: "S3",
  S3Compatible: "S3_COMPATIBLE",
  AzureBlobStorage: "AZURE_BLOB_STORAGE",
} as const;
